module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/workflow-2e5f7d1b120c949ce61ee14c42655379.svg";